import(/* webpackMode: "eager" */ "/codebuild/output/src1576343742/src/trustana-pim-fe/app/global-error.tsx");
